import { Flex, Image, Text } from "@chakra-ui/react";
import { NavbarItem } from "./NavbarItem/NavbarItem";
import { NavbarDropdownItem } from "./NavbarDropdownItem/NavbarDropdownItem";
import { NavBarList } from "../../shared/mock/NavBarList";
import { useNavigate } from "react-router-dom";
import shortLogo from "../../images/logo_short.svg";
import { useNavbar } from "../../context/NavbarContext";
import { FaSitemap, FaHandshake, FaUserPlus, FaCalendarAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import { selectUserRole } from "@/store/slices/user";
import { UserRole } from "../../api/auth/types";

export const NavBar = () => {
  const navigate = useNavigate();
  const { isOpen } = useNavbar();

  const role = useSelector((state) => selectUserRole(state));

  // Данные для dropdown партнерки
  const affiliateItems = [
    {
      text: "Лиды",
      href: "/leads",
      icon: FaUserPlus,
    },
    {
      text: "Контакты",
      href: "/leads_contacts",
      icon: FaCalendarAlt,
    },
    {
      text: "Партнеры",
      href: "/partners",
      icon: FaHandshake,
    },
  ];

  return (
    <Flex
      h="100vh"
      w={isOpen ? "254px" : "80px"}
      backgroundColor="white"
      flexDirection="column"
      borderRight="2px solid"
      borderColor="#e5e7eb"
      position="fixed"
      left={0}
      top={0}
      transition="width 0.3s ease"
      zIndex={10}
    >
      <Flex
        alignSelf={isOpen ? "start" : "center"}
        alignItems="center"
        justifyContent={isOpen ? "start" : "center"}
        mb="16px"
        gap="8px"
        borderBottom="1px solid #e5e7eb"
        padding="19px 16px 16px 16px"
        w="100%"
      >
        <Image
          src={shortLogo}
          height="28px"
          alignSelf={isOpen ? "start" : "center"}
          onClick={() => navigate(role === UserRole.ADMIN || role === UserRole.HRD ? "/departments" : "/my-department")}
          cursor="pointer"
        />
        {isOpen && (
          <Text fontSize="18px" lineHeight="28px" fontWeight={600} color="#3f3f46">
            G-Hunt
          </Text>
        )}
      </Flex>
      <Flex flexDirection="column" gap={2} flex={1} padding="0 16px 20px 8px">
        <NavbarItem
          text={`${role === UserRole.ADMIN || role === UserRole.HRD ? "Подразделения" : "Мое подразделение"}`}
          href={`${role === UserRole.ADMIN || role === UserRole.HRD ? "/departments" : "/my-department"}`}
          disabled={false}
          isCollapsed={!isOpen}
          icon={FaSitemap}
        />
        {NavBarList.slice(0, 5).map((el, index) => {
          return <NavbarItem key={index} disabled={el.disabled} isCollapsed={!isOpen} {...el} />;
        })}

        {/* Dropdown Партнерка */}
        {process.env.REACT_APP_STAND !== "DEMO" && (
          <NavbarDropdownItem text="Партнерка" icon={FaHandshake} isCollapsed={!isOpen} items={affiliateItems} />
        )}

        {NavBarList.slice(5).map((el, index) => {
          return <NavbarItem key={index + 5} disabled={el.disabled} isCollapsed={!isOpen} {...el} />;
        })}
      </Flex>
    </Flex>
  );
};
